export type Integration = {
  name: string
  logo: string
}

// Official brand marks served from the Simple Icons CDN, tinted to each
// brand's own hex value.
export const integrations: Integration[] = [
  { name: 'Xero', logo: 'https://cdn.simpleicons.org/xero/13B5EA' },
  { name: 'QuickBooks', logo: 'https://cdn.simpleicons.org/quickbooks/2CA01C' },
  { name: 'Sage', logo: 'https://cdn.simpleicons.org/sage/00D639' },
]

export const additionalIntegrations: string[] = [
  'FreeAgent',
  'KashFlow',
  'FreshBooks',
  'Sage 50',
  'Sage Intacct',
  'Twinfield',
]
